import { decodeTokenService } from "../services/decodeTokenService";

// ponytail: allowlist temporal por email mientras el sistema de marcas está en beta.
// Migrar a Flagr per-usuario si la lista crece o hay que togglear sin deploy.
const BRAND_FEATURE_ALLOWED_EMAILS = [
  "proyectosneuropublico@gmail.com",
  "stph4211@gmail.com",
];

export const canUseBrandFeature = () => {
  try {
    const email = decodeTokenService.getEmailFromToken()?.trim().toLowerCase();
    return !!email && BRAND_FEATURE_ALLOWED_EMAILS.includes(email);
  } catch {
    return false;
  }
};
